




import { Component, Vue } from "vue-property-decorator";
import utils from "../utils/utils";

@Component({
  components: {}
})
export default class Signin extends Vue {
  private error: any = "";

  mounted() {
    try {
      this.$oidcUserManager.signinRedirectCallback().then(user => {
        utils.writeCookieWithAccessToken(user.access_token);
        Signin.redirectToSuccessUrl();
      });
    } catch (error) {
      this.error = error;
      console.error("catchedError", error);
    }
  }

  private static redirectToSuccessUrl() {
    console.log(
      `ap-connect-redirectOnSuccessUrl: ${sessionStorage.getItem(
        "ap-connect-redirectOnSuccessUrl"
      )}`
    );
    location.href =
      sessionStorage.getItem("ap-connect-redirectOnSuccessUrl") || "/ap";
  }
}
